<template src="../templates/scenario-product-tree-actions.html" />

<script>
import FormButton from '@f/Button';

export default {
    name: 'ScenarioProductTreeActions',
    components: {
        FormButton,
    },
    props: {
        id: {
            type: Number,
            required: false,
            default: null,
        },
        editProducts: {
            type: Boolean,
            default: true,
        },
    },
    emits: ['action'],
    methods: {
        call(action, id = null) {
            this.$emit('action', {action, id});
        }
    }
};
</script>
